module.exports = __webpack_public_path__ + "img/mtbank_slide_2.fbb1e996.jpg";